//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  ERROR_MESSAGE_FOR_STOPPED_RESPONDING_APPLICATIONS_WITHIN_7_DAYS,
  MILLISECONDS_IN_A_WEEK,
} from '~/constants'
import {
  LOAN_WITHDRAWN_REASONS_OPTIONS,
  LOAN_WITHDRAWN_REASON_OTHER,
  LOAN_WITHDRAWN_REASON_STOPPED_RESPONDING,
  LABEL_YES_PROCEED,
  LABEL_CANCEL,
  LABEL_WITHDRAWN,
} from '~/constants/applications'

import { axiosErrorMessageExtractor } from '~/utils/error'
export default {
  props: {
    dialogOpened: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => null,
    },
    subtitle: {
      type: String,
      default: () => null,
    },
    decisionData: {
      type: Object,
      default: () => ({}),
    },
    reason: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      getIsDialogLoading: false,
      LOAN_WITHDRAWN_REASONS_OPTIONS,
      LOAN_WITHDRAWN_REASON_OTHER,
      getSelectedOutcomeOption: null,
      LABEL_WITHDRAWN,
      loanData: { ...this.decisionData },
      rules: {
        withdrawnReasonType: [
          {
            required: true,
            message: 'Withdraw reason type is required',
            trigger: ['blur', 'change'],
          },
        ],
        withdrawnReason: [
          {
            required: true,
            message: 'Withdraw reason field is required',
            trigger: ['blur', 'change'],
          },
        ],
      },
      LABEL_YES_PROCEED,
      LABEL_CANCEL,
    }
  },
  mounted() {
    this.$nuxt.$on('close-loader', () => {
      this.getIsDialogLoading = false
      this.closeDialog()
    })
  },
  beforeDestroy() {
    this.$nuxt.$off('close-loader')
  },
  computed: {
    loanDetailsForm() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.loanData = JSON.parse(JSON.stringify(this.decisionData))
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return { ...this.decisionData }
    },
    isWithdrawOther() {
      return this.loanData.withdrawnReasonType === LOAN_WITHDRAWN_REASON_OTHER
    },
  },
  methods: {
    closeDialog() {
      this.$nuxt.$emit('closeWithdrawDialog')
    },
    async submitForm() {
      try {
        const sFOpportunity = await this.$store.getters[
          'applications/getSFOpportunity'
        ]
        if (
          sFOpportunity.createdDate &&
          this.loanData.withdrawnReasonType ==
            LOAN_WITHDRAWN_REASON_STOPPED_RESPONDING &&
          new Date() - new Date(sFOpportunity.createdDate) <
            MILLISECONDS_IN_A_WEEK
        ) {
          this.$notify({
            title: 'Error',
            message:
              ERROR_MESSAGE_FOR_STOPPED_RESPONDING_APPLICATIONS_WITHIN_7_DAYS,
            type: 'error',
            duration: 5000,
          })
          return
        }
        this.getIsDialogLoading = true
        const { id, applicationId } = this.$route.params
        let isValid = false
        this.$refs.loanDetailsForm.validate((result) => {
          return (isValid = result)
        })
        if (!isValid) {
          this.getIsDialogLoading = false
          return
        }
        if (this.loanData?.loanDetails?.approval) {
          this.loanData.loanDetails.approval.outcomeOfAnApplication =
            LABEL_WITHDRAWN
          this.loanData.loanDetails.approval.withdrawnAt =
            new Date().toISOString()
        }
        await this.$store.dispatch('applications/setApplicationReasonTypes', {
          reasonTypes: { ...this.loanData },
          id,
          applicationId,
        })
        this.$nuxt.$emit('closeWithdrawDialog')
        if (this.loanData.loanDetails) {
          this.$nuxt.$emit(
            'withdrawSubmited',
            this.loanData.loanDetails.withdrawnAt
          )
        }
        this.getIsDialogLoading = false
      } catch (err) {
        this.getIsDialogLoading = false
        this.$notify({
          title: 'Error',
          message: axiosErrorMessageExtractor(err),
          type: 'error',
          duration: 5000,
        })
      }
    },
  },
}
